(function ($) {
    $(function () {
        // ==============================================================================
        // DINGEN VAN MARCO
        // ==============================================================================

        document.addEventListener("DOMContentLoaded", function (event) {
            // where formID is the element ID for your form
            const form = document.getElementById(formID);
            const submitListener = function (event) {
                event.preventDefault();
                let valid = true;
                /* Your validation logic here */
                if (valid) {
                    nocaptcha_handleCaptcha(form, form.submit.bind(form));
                }
            };
            form.addEventListener("submit", submitListener);
        });

        if ($(".redirect404").length) {
            window.location = "/404/";
        }

        $(".change_page").change(function () {
            window.location = $(this).val();
        });

        $(".changelang").on("change", function () {
            window.location = this.value;
        });

        $(".addfavorite").click(function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var id = $(this).data("id");

            $.ajax({
                url: url + "addfavorite",
                type: "GET",
                data: {
                    item_id: id,
                },
                success: function (response) {
                    $("#" + id + ".isfavorite").show();
                    $("#" + id + ".notfavorite").hide();
                },
                error: function () {
                    console.log("ajax error");
                },
            });
        });

        $(".removefavorite").click(function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var id = $(this).data("id");

            $.ajax({
                url: url + "removefavorite",
                type: "GET",
                data: {
                    item_id: id,
                },
                success: function (response) {
                    $("#" + id + ".isfavorite").hide();
                    $("#" + id + ".notfavorite").show();
                },
                error: function () {
                    console.log("ajax error");
                },
            });
        });

        $(".onlyfavorites").click(function (e) {
            e.preventDefault();
            var url = $(this).attr("href");

            $.ajax({
                type: "GET",
                url: url + "onlyfavorites",
            }).done(function (data) {
                $(".projects").html(data);
                $(".casestudies").html(data);
            });
        });

        /*
		Klant type
	*/

        if ($("#popup--particulier-proffesioneel").length) {
            $.featherlight($("#popup--particulier-proffesioneel"));
        }

        $(".target").click(function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var type = $(this).data("type");

            $.ajax({
                url: "/function/target",
                type: "GET",
                data: {
                    item_type: type,
                },
                success: function (response) {
                    window.location = url;
                    // console.log(response);
                },
                error: function () {
                    console.log("ajax error");
                },
            });
        });

        /*
		Nieuws
	*/

        $(".tag").click(function (e) {
            e.preventDefault();
            if ($(this).hasClass("current")) {
                $(this).removeClass("current");
            } else {
                $(this).addClass("current");
            }

            if ($(this).data("id") == "0") {
                $(".tag").removeClass("current");
                $(this).addClass("current");
            } else {
                $('.tag[data-id="0"]').removeClass("current");
            }

            if (!$(".tag").hasClass("current")) {
                $('.tag[data-id="0"]').addClass("current");
            }

            show_news();
        });

        $(".reset_tags").click(function (e) {
            e.preventDefault();
            $(".tag").removeClass("current");

            show_news();
        });

        function get_filters() {
            var tags = [];
            $.each($(".tag"), function () {
                if ($(this).hasClass("current")) {
                    tags.push($(this).data("id"));
                }
            });

            return tags;
        }

        function show_news() {
            var tags = get_filters();
            var url = $(".filter--form").data("url");

            $.ajax({
                type: "GET",
                data: { tags: tags },
                url: url,
            }).done(function (data) {
                $(".articles").html(data);
            });
        }

        /*
		Projects
	*/

        $(".change_application").change(function () {
            var application_id = $(".application").val();
            var url = $(".filter--form").data("url");

            $.ajax({
                type: "GET",
                data: { application_id: application_id },
                url: url + "change_application",
                dataType: "JSON",
            }).done(function (data) {
                $(".show_subapplication").hide();
                if (data) {
                    if (data.length) {
                        var $select = $(".subapplication");
                        $(".show_subapplication").show();
                        $select.find("option").remove();
                        $select.append(
                            $("<option />")
                                .val("")
                                .text($(".show_subapplication").data("all"))
                        );
                        $.each(data, function () {
                            $select.append(
                                $("<option />").val(this.value).text(this.text)
                            );
                        });
                    }
                }
            });
        });

        $(document).on("change", ".filter_project", function () {
            var product_id = $(".product").val();
            var application_id = $(".application").val();
            var subapplication_id = $(".subapplication").val();

            show_projects(product_id, application_id, subapplication_id);
        });

        $(".reset_filters").click(function (e) {
            e.preventDefault();
            $('.filter_project option[value=""]').attr("selected", "selected");

            show_projects("", "");
        });

        function show_projects(product_id, application_id, subapplication_id) {
            var url = $(".filter--form").data("url");

            $.ajax({
                type: "GET",
                data: {
                    product_id: product_id,
                    application_id: application_id,
                    subapplication_id: subapplication_id,
                },
                url: url,
            }).done(function (data) {
                $(".projects").html(data);
            });
        }

        /*
		Toepassingen
	*/

        $(document).on("change", ".filter_project_application", function () {
            var product_id = $(".product").val();
            var application_id = $(".application").val();
            var subapplication_id = $(".subapplication").val();

            show_projects_application(
                product_id,
                application_id,
                subapplication_id
            );
        });

        $(".reset_filters").click(function (e) {
            e.preventDefault();
            $('.filter_project option[value=""]').attr("selected", "selected");

            show_projects_application("", "");
        });

        function show_projects_application(
            product_id,
            application_id,
            subapplication_id
        ) {
            var url = $(".filter--form").data("url");

            $.ajax({
                type: "GET",
                data: {
                    product_id: product_id,
                    application_id: application_id,
                    subapplication_id: subapplication_id,
                },
                url: url,
            }).done(function (data) {
                $(".projects").html(data);
            });
        }
        /*
		Case studies
	*/

        $(".application").click(function (e) {
            e.preventDefault();
            if ($(this).hasClass("current")) {
                $(this).removeClass("current");
            } else {
                $(this).addClass("current");
            }

            if ($(this).data("id") == "0") {
                $(".application").removeClass("current");
                $(this).addClass("current");
            } else {
                $('.application[data-id="0"]').removeClass("current");
            }

            if (!$(".application").hasClass("current")) {
                $('.application[data-id="0"]').addClass("current");
            }

            show_casestudies();
        });

        $(".reset_applications").click(function (e) {
            e.preventDefault();
            $(".application").removeClass("current");

            show_casestudies();
        });

        function get_application_filters() {
            var applications = [];
            $.each($(".application"), function () {
                if ($(this).hasClass("current")) {
                    applications.push($(this).data("id"));
                }
            });

            return applications;
        }

        function show_casestudies() {
            var applications = get_application_filters();
            var url = $(".filter--form").data("url");

            $.ajax({
                type: "GET",
                data: { applications: applications },
                url: url,
            }).done(function (data) {
                $(".casestudies").html(data);
            });
        }
    });
})(jQuery);
